import logo from 'assets/header-prevencor-xx.png';
import AssinaturaEletronica from 'components/core/AssinaturaEletronica';
import ServiceUnavailableAlert from 'components/core/ServiceUnavailableAlert';
import LaudoActionButtons from 'components/laudos/LaudoActionButtons';
import { Alert, Button, Card, Form, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useStressById } from 'services/stress';
import 'styles/laudo-base.css';
import { isInfrastructureError } from 'utils/apiErrors';
import { generatePDFStress } from './generatePDFStress';
import { getStressRichTextContent, hasStressDocumentContent } from './stressRichText';

function RichReportSection({ htmlContent }) {
  const hasContent = hasStressDocumentContent(htmlContent);

  return (
    <Form.Group className="mt-3">
      {hasContent ? (
        <div
          className="stress-rich-report"
          style={{
            whiteSpace: 'pre-wrap',
            fontFamily: '"Courier New", Courier, monospace',
            fontSize: '14px',
            lineHeight: '1.5',
          }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      ) : (
        <div className="text-muted">Sem descrição preenchida.</div>
      )}
    </Form.Group>
  );
}

export default function ReportStress() {
  const { id } = useParams();
  const {
    data: stressData,
    isLoading,
    isNotFound,
    error,
    mutate: refetchStress,
  } = useStressById(id);

  if (isLoading && !stressData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '400px' }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (isNotFound && !stressData) {
    return (
      <div className="alert alert-warning m-3">
        O registro com ID <strong>{id}</strong> não foi encontrado no sistema.
      </div>
    );
  }

  const hasError = Boolean(error);
  const isInfraError = isInfrastructureError(error);

  if (hasError && !stressData) {
    return isInfraError ? (
      <ServiceUnavailableAlert error={error} onRetry={() => refetchStress()} />
    ) : (
      <div className="alert alert-danger m-3 text-center">
        <p className="mb-2">
          {error?.message ||
            'Ocorreu um erro ao carregar as informações. Tente novamente mais tarde.'}
        </p>
        <Button variant="outline-danger" size="sm" onClick={() => refetchStress()}>
          Tentar novamente
        </Button>
      </div>
    );
  }

  const conteudoHtmlSanitizado = stressData ? getStressRichTextContent(stressData) : '';

  return (
    <Card className="mb-2 mt-2">
      <Card.Header className="text-center">
        <img
          src={logo}
          alt="Prevencor"
          style={{ display: 'block', maxWidth: '100%', margin: '0 auto 8px' }}
          className="no-print"
        />
        <h4 className="font-weight-bold">LAUDO DE ECOCARDIOGRAMA DE STRESS</h4>
      </Card.Header>

      <Card.Body>
        {hasError &&
          stressData &&
          (isInfraError ? (
            <ServiceUnavailableAlert error={error} stale onRetry={() => refetchStress()} />
          ) : (
            <Alert variant="warning" className="mb-3 no-print">
              Não foi possível atualizar os dados mais recentes.{' '}
              <Button variant="link" size="sm" className="p-0" onClick={() => refetchStress()}>
                Tentar novamente
              </Button>
            </Alert>
          ))}
        <strong className="mr-auto">Paciente: </strong>
        {`${stressData?.CODPAC || '--'} - ${stressData?.NOMEPAC || '--'}`}
        <br />
        <strong className="mr-auto">Data de Nasc: </strong>
        {stressData?.dataNasc || '--'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Sexo: </strong>
        {stressData?.SEXOPAC || '--'}
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Idade: </strong>
        {stressData?.IDADEPAC ? `${stressData.IDADEPAC} anos` : '--'}
        <br />
        <strong className="mr-auto">Convênio: </strong>
        {stressData?.SIGLACONV || '--'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Código: </strong>
        {stressData?.CODSTRESS || '--'}&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Data do Exame: </strong>
        {stressData?.dataFormatada || '--'}
        <br />
        <strong className="mr-auto">Tipo de Stress: </strong>
        {stressData?.TIPOSTRESS || '--'}
        <br />
        <strong className="mr-auto">Médico que Realizou: </strong>
        Dr(a). {stressData?.Realizou || '--'}
        <br />
        <strong className="mr-auto">Médico que Solicitou: </strong>
        Dr(a). {stressData?.Solicitou || '--'}
        <hr />
        <RichReportSection htmlContent={conteudoHtmlSanitizado} />
      </Card.Body>

      <Card.Footer className="text-center no-print">
        <LaudoActionButtons
          actions={[
            {
              key: 'timbrado',
              label: 'Imprimir Timbrado',
              onClick: () => generatePDFStress({ stress: stressData }),
            },
          ]}
        />
      </Card.Footer>

      <Card.Footer className="text-center">
        <AssinaturaEletronica
          data={stressData}
          nome={stressData?.Realizou}
          showPrintButton={false}
        />
      </Card.Footer>
    </Card>
  );
}
